export class Installment {
	payToday;
	nextPaymentDate;
	selectedFrequency;
	totalAmount: string;
	number: number;
	firstPayment: number;
	paymentAfterFirst: number;
	discountPercent: number;
}
